import { DemoApiMock } from '../types'
import { matchRestRequest } from '../utils'
import { positionTemplateGroups } from '../data/positionTemplateGroups'

export const mockGetPositionTemplateGroups: DemoApiMock = {
  shouldMock: (request) =>
    matchRestRequest(
      request,
      '/company/graphql_dispatch/position_template_groups_867f2b9c',
      'POST'
    ),
  getResponse: async () => {
    return {
      data: {
        company: {
          positionTemplateGroups,
        },
      },
    }
  },
}
